module.exports = __webpack_public_path__ + "img/Frame_25.5355f6dc.png";